import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2907415851/src/app/[locale]/(site)/_components/LandingHomePage.tsx");
